/**
 * Šablóna karty výberu veľkosti podlažia.
 * @param floorNumber číslo podlažia
 * @returns {string} html karty podlažia
 */
const floorCardTemplate = (floorNumber) => {
  return `
    <div class="card" id="floor-card_${floorNumber}">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Podlažie ${floorNumber}</h5>
            <button
                type="button"
                class="btn btn-outline-primary d-flex align-items-center justify-content-center p-1 remove-floor-card"
            >
                <svg
                    focusable="false"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
                </svg>
            </button>
        </div>
        <div class="card-body">
            <label for="floor_${floorNumber}">Veľkosť podlažia</label>
            <select class="custom-select" id="floor_${floorNumber}" name="floor" required>
                <option selected value="">Vyberte veľkosť podlažia</option>
                <option value="18">do 40 m² - 18,00 €</option>
                <option value="24">do 80 m² - 24,00 €</option>
                <option value="30">do 120 m² - 30,00 €</option>
                <option value="36">do 200 m² - 36,00 €</option>
            </select>
        </div>
    </div>`
}

const formatPrice = (price) => price.toFixed(2).replace(".", ",")

const renderOrderSummary = (floorSelection) => {
  let total = 0

  const floorSelects = floorSelection.querySelectorAll(".custom-select")

  let orderSummaryRows = ""

  floorSelects.forEach((select) => {
    if (select.value !== "") {
      const price = Number.parseFloat(select.value)
      total += price

      const floorNumber = select.id.replace("floor_", "")
      const floorSize = select.options[select.selectedIndex].text.split(
        " - "
      )[0]

      orderSummaryRows += `
          <tr>
              <th scope="row">Podlažie ${floorNumber}</th>
              <td class="text-right">veľkosť ${floorSize}</td>
              <td class="text-right">${formatPrice(price)} €</td>
          </tr>
      `
    }
  })

  const orderSummaryEl = document.getElementById("order-summary")

  if (total > 0) {
    orderSummaryEl.innerHTML = `
        <h4 class="mb-2 mb-md-3 mt-4 mt-md-5">Zhrnutie objednávky</h4>
        <table class="table">
            <tbody>
            ${orderSummaryRows}
            </tbody>
            <tfoot>
                <tr class="font-size-lg font-weight-bold">
                    <td colspan="2" class="text-right">Celkom</td>
                    <td class="text-right">${formatPrice(total)} €</td>
                </tr>
            </tfoot>
        </table>`
  } else {
    orderSummaryEl.innerHTML = ""
  }
}

/**
 * Voľba podlaží vo formulári pre objednávku 3D pôdorysu.
 */
const initFloorForm = () => {
  const floorSelection = document.getElementById("floor-selection")

  if (floorSelection !== null) {
    let floorNumber = 1

    // výpočet sumy pri zmene hodnoty selectu
    document
      .getElementById("floor_1")
      .addEventListener("change", () => renderOrderSummary(floorSelection))

    const addFloorBtn = document.getElementById("add-floor")

    // pridanie ďalšieho podlažia
    addFloorBtn.addEventListener("click", () => {
      floorNumber += 1
      floorSelection.insertAdjacentHTML(
        "beforeend",
        floorCardTemplate(floorNumber)
      )

      const card = document.getElementById(`floor-card_${floorNumber}`)

      // aktivácia možnosti zavrieť kartu
      const removeCardBtn = card.querySelector("button.remove-floor-card")
      removeCardBtn.addEventListener("click", () => {
        card.remove()
        renderOrderSummary(floorSelection)
      })

      // výpočet sumy pri zmene hodnoty selectu
      document
        .getElementById(`floor_${floorNumber}`)
        .addEventListener("change", () => renderOrderSummary(floorSelection))
    })
  }
}

export default initFloorForm
